


export const GETLOGINDATAREQUEST = "GETLOGINDATAREQUEST"
export const GETLOGINDATASUCCESS = "GETLOGINDATASUCCESS"
export const GETLOGINDATAFALIURE = "GETLOGINDATAFALIURE"